import { useMatch } from "react-router-dom";

export default function IsFicha() {
  const matchCarros = useMatch("carros/:marca/:modelo/:codViatura");
  const matchMotas = useMatch("motas/:marca/:modelo/:codViatura");
  const matchBarcos = useMatch("barcos/:marca/:modelo/:codViatura");

  return !!matchCarros || !!matchMotas || !!matchBarcos;
}
